/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiEducationalLevelOverviewGet } from '../fn/educational-level/api-educational-level-overview-get';
import { ApiEducationalLevelOverviewGet$Params } from '../fn/educational-level/api-educational-level-overview-get';
import { apiEducationalLevelSyncPost } from '../fn/educational-level/api-educational-level-sync-post';
import { ApiEducationalLevelSyncPost$Params } from '../fn/educational-level/api-educational-level-sync-post';
import { EducationalLevelOverviewList } from '../models/educational-level-overview-list';
import { ImportResult } from '../models/import-result';


/**
 * Educational level service
 */
@Injectable({ providedIn: 'root' })
export class EducationalLevelService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiEducationalLevelOverviewGet()` */
  static readonly ApiEducationalLevelOverviewGetPath = '/api/educational-level/overview';

  /**
   * Get educational level overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEducationalLevelOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEducationalLevelOverviewGet$Response(params?: ApiEducationalLevelOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationalLevelOverviewList>> {
    return apiEducationalLevelOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get educational level overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEducationalLevelOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEducationalLevelOverviewGet(params?: ApiEducationalLevelOverviewGet$Params, context?: HttpContext): Observable<EducationalLevelOverviewList> {
    return this.apiEducationalLevelOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<EducationalLevelOverviewList>): EducationalLevelOverviewList => r.body)
    );
  }

  /** Path part for operation `apiEducationalLevelSyncPost()` */
  static readonly ApiEducationalLevelSyncPostPath = '/api/educational-level/sync';

  /**
   * Upsert a/some education level.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEducationalLevelSyncPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiEducationalLevelSyncPost$Response(params: ApiEducationalLevelSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResult>> {
    return apiEducationalLevelSyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert a/some education level.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEducationalLevelSyncPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiEducationalLevelSyncPost(params: ApiEducationalLevelSyncPost$Params, context?: HttpContext): Observable<ImportResult> {
    return this.apiEducationalLevelSyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportResult>): ImportResult => r.body)
    );
  }

}
